// Toggle Login/Registration tab
const removeLoginTabActiveClass = (parentElem) => {
  const navLinks = parentElem.querySelectorAll('.login-registration-form__nav-link.is-active');
  const tabPanels = parentElem.querySelectorAll('.login-registration-form__tabpanel.is-active');
  const activeItems = [...navLinks, ...tabPanels];
  activeItems.forEach((elem) => {
    elem.classList.remove('is-active');
  });
};

attachEvent('.login-registration-form__nav-link, .login-registration-form__nav-link-bottom', 'click', (ev) => {
  const button = ev.target;
  const parentElem = button.closest('.login-registration-form');
  const tabId = button.getAttribute('aria-controls');
  const panelElement = parentElem.querySelector(`#${tabId}`);
  removeLoginTabActiveClass(parentElem);
  parentElem.querySelector(`[data-tab-id=${tabId}]`).click();
  panelElement.classList.add('is-active');
  ev.preventDefault();
});

const hashValue = location.hash.slice(1);
if (hashValue) {
  const targetTabLink = document.querySelector(`[data-tab-id="${hashValue}"]`);

  if (targetTabLink) {
    targetTabLink.click();
  }
}
